export default "__VITE_ASSET__DXO43Kou__"